import { PaddingOptions } from 'mapbox-gl';
import { LineString } from 'geojson';

import { Mote } from '../models';
import { GeocodeFeature } from '@mapbox/mapbox-sdk/services/geocoding';

/**
* Interface for Directions Response returned by Mapbox API
* Other parameters are availbale, see: https://docs.mapbox.com/api/navigation/#route-object
*/
export interface DirectionsResponse {
    geometry: LineString,
    distance: number,
    duration: number,
    legs: any[],
    routingProfile: RoutingProfile
}

/**
* Enum that describes the routing profile to use. Possible values are mapbox/driving-traffic, mapbox/driving, mapbox/walking, or mapbox/cycling.
* Docs: https://docs.mapbox.com/api/navigation/#retrieve-directions
*/
export enum RoutingProfile {
    DRIVING = 'mapbox/driving',
    WALKING = 'mapbox/walking',
    CYCLING = 'mapbox/cycling',
    JOURNEY = 'journey/public'
}

/**
* Enum that determines the type of a Direction Event. Used as a state controller across components and in conjunction with SearchDirectionsService
*/
export enum DirectionsEventType {
    STOP_NAVIGATION = 'STOP_NAVIGATION',
    START_NAVIGATION = 'START_NAVIGATION',
    SUGGEST_NAVIGATION = 'SUGGEST_NAVIGATION',
    ERROR = 'ERROR',
    INITIAL = 'INITAL'
}

/**
* Interface for Directions Events. Can be directions to either a Mote or a Search result depending on type
*/
export interface DirectionsEvent {
    type: DirectionsEventType,
    name?: string,
    mote?: Mote,
    geocodeFeature?: GeocodeFeature,
    error?: string,
    distance?: number,
    suggestProfile?: boolean, // Allow planner to auto suggest route on start event
    mapPadding?: PaddingOptions
}
